export enum TABLE_FIELDS_LABLES {
  ID = 'ID',
  NAME = 'Name',
  EMAIL = 'Email',
  DATE_OF_BIRTH = 'Date Of Birth',
  STATUS = 'Status',
  CLINIC_ROLE = 'Clinic Role',
}

export enum TABLE_FIELDS {
  ID = 'id',
  NAME = 'name',
  EMAIL = 'email',
  DATE_OF_BIRTH = 'dateOfBirth',
  STATUS = 'status',
  CLINIC_ROLE = 'clinicRole',
}
